// Third-party
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

// Constants
import { NAV_PATHS } from '../../../utils/constants';

// Utils
import { FormattedMessage } from '../../../utils/i18n';

// Components
import { Button } from '@capintel/component-lib/button';

// Images
import { ReactComponent as AccountLockImg } from '../../../images/account-lock.svg?react';

const Locked = (props: RouteComponentProps) => (
  <div className="locked">
    <div className="image-container">
      <AccountLockImg />
    </div>
    <h3>
      <FormattedMessage id="Auth.Locked.Title" />
    </h3>
    <p>
      <FormattedMessage id="Auth.Locked.SubTitle1" />
    </p>
    <p>
      <FormattedMessage id="Auth.Locked.SubTitle2" />
    </p>
    <div className="button-container">
      <Button variant="primary" onClick={() => props.history.replace(`${NAV_PATHS.AUTH}/login`)}>
        <FormattedMessage id="Auth.Locked.Button" />
      </Button>
    </div>
  </div>
);

export default withRouter(Locked);
